import * as yup from "yup";

export const ownerInfoSchema = (t) => {
  return yup
    .object({
      password: yup
        .string()
        .required(t("login.input.password.validations.emptyText")),
    })
    .required();
};
